<template>
  <alchemy-map />
</template>
<script>
import alchemyMap from "./components/scoped/map";
export default {
  components: {
    "alchemy-map": alchemyMap
  }
};
</script>
